export default __webpack_public_path__ + "static/media/help_242210.aa0d1890.svg";